<template>
  <section class="filters-block-mobile" v-if="filterParams">
    <el-row :gutter="60" style="padding-bottom: 20px">
      <el-col :xl="7" :lg="7" style="padding-bottom: 20px">
        <Rooms
          :list="Object.entries(filterParams.rooms)"
          :selectedValue="flatFilter.rooms"
          @change="filterHandler({ rooms: $event })"
        />
      </el-col>
      <el-col :xl="17" :lg="17">
        <Types
          :list="filterParams.type_realties"
          :selectedValue="flatFilter.type_realty"
          @change="filterHandler({ type_realty: $event })"
        />
      </el-col>
    </el-row>
    <el-row style="padding-bottom: 20px">
      <Districts
        :list="filterParams.districts"
        :selectedValue="flatFilter.districts"
        @change="filterHandler({ districts: $event })"
      />
    </el-row>
    <el-row>
      <Prices
        :min="filterParams.price.start"
        :max="filterParams.price.end"
        :selectedValue="flatFilter.price"
        @change="filterHandler({ price: $event })"
      />
    </el-row>
    <!-- Additional filters -->
    <el-row>
      <el-col>
        <el-collapse-transition>
          <el-col class="additional-filter" v-show="isAdditionalFilter">
            <el-row>
              <el-col :xl="9" :lg="9">
                <Floors
                  :list="Object.entries(filterParams.floor)"
                  :selectedValue="flatFilter.floor"
                  @change="filterHandler({ floor: $event })"
                />
              </el-col>
              <el-col :xl="15" :lg="15">
                <State
                  :list="filterParams.states"
                  :selectedValue="flatFilter.states"
                  @change="filterHandler({ states: $event })"
                />
              </el-col>
            </el-row>
            <el-row>
              <Plannings
                :list="filterParams.plannings"
                :selectedValue="flatFilter.plannings"
                @change="filterHandler({ plannings: $event })"
              />
            </el-row>
            <el-row>
              <el-col :xl="8" :lg="8">
                <Materials
                  :list="Object.entries(filterParams.material)"
                  :selectedValue="flatFilter.material"
                  @change="filterHandler({ material: $event })"
                />
              </el-col>
              <el-col :xl="16" :lg="16">
                <Square
                  :min="filterParams.area.start"
                  :max="filterParams.area.end"
                  :selectedValue="flatFilter.area"
                  @change="filterHandler({ area: $event })"
                />
              </el-col>
            </el-row>
          </el-col>
        </el-collapse-transition>
        <button
          type="button"
          class="transparent-btn additional-filter-btn mobile-transparent-filter"
          @click="isAdditionalFilter = !isAdditionalFilter"
          
        >
        <div class="mobile-rotate-arrow-button" >
 <span v-if="!isAdditionalFilter" class="hidden-xs-only">Показати</span
          ><span v-else class="hidden-xs-only">Сховати</span>
          <span v-if="!isAdditionalFilter" class="hidden-sm-and-up">Розширенний фільтр</span
          ><span v-else class="hidden-sm-and-up change-filter-position">Основний фільтр</span>
          <span style="padding-left: 2px; padding-right: 8px" class="hidden-xs-only"
            >розширенний фільтр</span
          >
          <div class="rotate mobile-rotate" >
            <img
              src="@/assets/images/arrow.png"
              alt="arrow"
              class="transition"
              :class="{ rotate: isAdditionalFilter }"
            />
          </div>
        </div>
         
        </button>
      </el-col>
    </el-row>
  </section>
 
</template>

<script>
import Rooms from '@/components/common/filter_partials/Rooms'
import Types from '@/components/common/filter_partials/Types'
import Districts from '@/components/common/filter_partials/Districts'
import Prices from '@/components/common/filter_partials/Prices'
import Floors from '@/components/common/filter_partials/Floors'
import State from '@/components/common/filter_partials/State'
import Plannings from '@/components/common/filter_partials/Plannings'
import Materials from '@/components/common/filter_partials/Materials'
import Square from '@/components/common/filter_partials/Square'
import { mapGetters } from 'vuex'
export default {
  name: 'FiltersMobile',
  components: {
    Square,
    Materials,
    Plannings,
    State,
    Floors,
    Prices,
    Districts,
    Types,
    Rooms,
  },
  computed: {
    ...mapGetters({
      filterParams: 'getFlatsFilterParams',
      flatFilter: 'getFlatsFilter',

      currency: 'getGlobalCurrency',
      usdCourse: 'getUsdCourse',
    }),
  },
  data() {
    return {
      isAdditionalFilter: false,
    }
  },
 
  methods: {
    filterHandler(value) {
      this.$store.dispatch('changeFlatsFilter', {
        ...this.flatFilter,
        ...value,
      })
    },
  },
}
</script>

<style scoped></style>
